<div mat-dialog-title class="title">
  <span class="dialog-title-text">E-Signature</span>
</div>

<mat-dialog-content style="color: black !important;">


    <div style="margin-top:25px;" [innerHTML]="consentSignPopUpHeaderHtmlContent"></div>

    <div *ngFor="let que of consentSignQuestions;let queInd = index;">
      <div *ngIf="que!= null">
              
        <div *ngIf="que.inputType === 'sign' && que.isParentQuestionVisible"
          [ngClass]="{'border-Btm': queInd +1 != consentSignQuestions.length}">
          <app-inputType-sign [questionIndex]="queInd"
            [IsReadOnly]=" que.responseReadOnly ||  (que.displayMode=='ED' && !que.enableQuestion )"
            [question]=que (childQuestion)="UpdateResponse($event)" [IsConsentScreen]="true" >
          </app-inputType-sign>
          <!-- <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                  </ng-container> -->
        </div>
       

      </div>
    </div>



    <div *ngIf="showError" class="error-text">
      Please sign your application before submission
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <hr class="separator">
  <div class="d-flex justify-content-center align-items-center" style="margin-right: 1.5rem;">
    <button mat-button class="btn-style btnWidth-small" (click)="ok()">Ok</button>
    <button mat-button class="btn-style btnWidth-small" (click)="close()">Close</button>
  </div>
</mat-dialog-actions>
